'use strict';

var style = require('./style');

module.exports = style({
  prop: 'fontWeight',
  key: 'fontWeights'
});


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/styled-system/dist/font-weight.js
// module id = 4490
// module chunks = 168707334958949